/* Peauxdemouton.fr echelle cadeaux (portee fra Lammeskindet.dk 2026-08-31, LSDKK-struktur):
   2+ varer = gratis brosse (NCL1308), 3+ varer = 10% ordre-rabat (Automatic "10% DE REDUCTION EXTRA - 3+ articles", min 4 enheder inkl. gavelinjen - styres ikke her).
   Saedehynder (type 'Seat Covers') taeller MED i trappen ved 1-5 stk; ved 6+ opbruger 6-for-5-rabatten (16,67%) enhederne.
   TEMA: FoxTheme (nyere Xtra-variant) med <cart-drawer>/<cart-items> web components.
   - refreshUI: dispatch 'cart:refresh' (CartDrawer.onCartRefresh genhenter hele sektionen); paa /cart-siden reload.
   - Ingen qty-fix noedvendig: CartItems binder selv delegeret change-listener og genopstaar efter hver render.
   - Milestone-boks + gave-badge injiceres CLIENT-SIDE (guarded mod observer-loops via data-ns-hash),
     fordi cart-drawer.liquid/main-cart.liquid ikke redigeres paa denne shop.
   - Linjer: drawer = li.cart-item (id CartDrawer-Item-N), kurvside = tr.cart-item (id CartItem-N) -> selector '.cart-item'.
   - BxGy-rabatpiller: Shopify saetter en 0-kr-allokering paa BUYS-linjerne, saa temaet viser "Brosse OFFERTE"-pillen
     paa fuldpris-produkter. Dekoratoren FJERNER pillen paa linjer uden reel prisreduktion, og paa gavelinjen
     (badgen kommunikerer det). Linjer med reel rabat (fx 6 POUR 5, linje-splits) beholder deres pille. */
(function () {
  var TIERS = [
    { min: 2, variant: 55847538098511 }
  ];
  var GIFT_VARIANTS = [55847538098511];
  var EXCLUDE_TYPE = 'Seat Covers';
  var PROP = '_free_gift';
  var GIFT_HANDLE = 'ncl1308';
  var FILLS = [
    { cover: 'ns1007', fill: 'ncl5157', label: '40x40' },
    { cover: 'ns1008', fill: 'ncl5159', label: '50x50' }
  ];
  var ACC_HANDLE = 'ncl5231';
  var busy = false;
  var productCache = {};

  function money(cents) {
    try { return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  function getProduct(handle) {
    if (Object.prototype.hasOwnProperty.call(productCache, handle)) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache[handle] = p; return p; })
      .catch(function () { productCache[handle] = null; return null; });
  }

  function isExcluded(it) { return it.product_type === EXCLUDE_TYPE; }

  function cartState(cart) {
    var giftLines = [], nonGiftQty = 0, hyndeQty = 0, variantPresent = {};
    (cart.items || []).forEach(function (it) {
      variantPresent[it.variant_id] = true;
      if (GIFT_VARIANTS.indexOf(it.variant_id) !== -1 && it.properties && it.properties[PROP]) giftLines.push(it);
      else if (isExcluded(it)) hyndeQty += it.quantity;
      else nonGiftQty += it.quantity;
    });
    if (hyndeQty > 0 && hyndeQty < 6) nonGiftQty += hyndeQty;
    return { giftLines: giftLines, nonGiftQty: nonGiftQty, hyndeQty: hyndeQty, variantPresent: variantPresent };
  }

  function onCartPage() { return location.pathname.replace(/\/$/, '') === '/cart'; }

  function refreshUI() {
    try {
      if (onCartPage()) { window.location.reload(); return; }
      var d = document.querySelector('cart-drawer');
      var isOpen = false;
      try { isOpen = !!(d && d.open); } catch (e) {}
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: isOpen } }));
      scheduleInject();
    } catch (e) { console.log('ns-gift refreshUI', e); }
  }

  function mutate(url, payload) {
    return fetch(url + '?ns_gift=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function reconcile() {
    if (busy) return;
    busy = true;
    fetch('/cart.js?ns_gift=1').then(function (r) { return r.json(); }).then(function (cart) {
      var st = cartState(cart);
      var target = null;
      for (var i = 0; i < TIERS.length; i++) { if (st.nonGiftQty >= TIERS[i].min) { target = TIERS[i]; break; } }

      var dismissedVar = sessionStorage.getItem('nsGiftDismissed') || '';
      var prevTier = sessionStorage.getItem('nsGiftTier') || '';

      if (target && prevTier === String(target.variant) && st.giftLines.length === 0 && !st.variantPresent[target.variant]) {
        sessionStorage.setItem('nsGiftDismissed', String(target.variant));
        dismissedVar = String(target.variant);
      }
      if (!target) { sessionStorage.removeItem('nsGiftDismissed'); dismissedVar = ''; }
      var dismissed = target && dismissedVar === String(target.variant);

      var ops = [];
      st.giftLines.forEach(function (gl) {
        if (!target || gl.variant_id !== target.variant) ops.push({ id: gl.key, quantity: 0 });
        else if (gl.quantity > 1) ops.push({ id: gl.key, quantity: 1 });
      });
      var needAdd = target && !st.variantPresent[target.variant] && !dismissed;

      var chain = Promise.resolve(null);
      ops.forEach(function (op) {
        chain = chain.then(function () { return mutate('/cart/change.js', { id: op.id, quantity: op.quantity }); });
      });
      if (needAdd) {
        chain = chain.then(function () {
          var props = {}; props[PROP] = '1';
          return mutate('/cart/add.js', { id: target.variant, quantity: 1, properties: props });
        });
      }

      chain.then(function () {
        sessionStorage.setItem('nsGiftTier', target ? String(target.variant) : '');
        if (ops.length || needAdd) refreshUI();
        else scheduleInject();
        busy = false;
      }).catch(function () { busy = false; });
    }).catch(function () { busy = false; });
  }

  var CART_MUTATION = /\/cart\/(add|change|update|clear)/;

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    try {
      if (CART_MUTATION.test(url) && url.indexOf('ns_gift=1') === -1) {
        p.then(function () { setTimeout(reconcile, 150); }, function () {});
      }
    } catch (e) {}
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__nsGiftUrl = url;
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    try {
      var u = this.__nsGiftUrl || '';
      if (CART_MUTATION.test(u) && u.indexOf('ns_gift=1') === -1) {
        this.addEventListener('load', function () { setTimeout(reconcile, 150); });
      }
    } catch (e) {}
    return origSend.apply(this, arguments);
  };

  /* Quick-add knapper (.ns-quickadd med data-variant) */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.ns-quickadd') : null;
    if (!b) return;
    e.preventDefault();
    var v = parseInt(b.getAttribute('data-variant') || '', 10);
    if (!v) return;
    if (b.classList.contains('ns-qa-busy')) return;
    b.classList.add('ns-qa-busy');
    mutate('/cart/add.js', { id: v, quantity: 1 }).then(function (json) {
      b.classList.remove('ns-qa-busy');
      if (json) { refreshUI(); setTimeout(reconcile, 200); }
    });
  });

  /* ---------- Milestone-boks + gave-badge (client-side, guarded) ---------- */

  var STYLE_CSS = '.ns-gift-steps{display:block;background:#eef5ee;border:1px solid #cfe0cf;color:#2f4f38;padding:12px 14px;border-radius:6px;font-size:.92em;line-height:1.5;margin:0 0 14px 0;}' +
    '.ns-gift-steps ul{list-style:none;margin:0;padding:0;}' +
    '.ns-gift-steps li{margin:0 0 4px 0;padding:0;}' +
    '.ns-gift-steps li:last-child{margin-bottom:0;}' +
    '.ns-gift-steps a{color:#2f4f38;text-decoration:underline;}' +
    '.ns-bar{display:flex;gap:4px;margin:0 0 10px 0;}' +
    '.ns-bar span{flex:1;height:6px;border-radius:3px;background:#d5e4d5;}' +
    '.ns-bar span.ns-fill{background:#3A6546;}' +
    '.ns-gift-badge{display:inline-block;background:#3A6546;color:#fff;font-size:.72em;font-weight:bold;letter-spacing:.03em;padding:2px 8px;border-radius:4px;margin:4px 0;text-transform:uppercase;}' +
    '.ns-quickadd{display:inline-block;background:#3A6546;color:#fff !important;text-decoration:none !important;font-size:.85em;font-weight:bold;padding:3px 12px;border-radius:14px;margin:2px 2px 2px 4px;cursor:pointer;white-space:nowrap;}' +
    '.ns-quickadd:hover{background:#2f5238;}' +
    '.ns-qa-busy{opacity:.5;pointer-events:none;}' +
    '.ns-gift-locked .quantity__button{display:none !important;}' +
    '.ns-gift-locked .quantity__input{pointer-events:none;}';

  function ensureStyle() {
    if (!document.getElementById('ns-gift-style')) {
      var s = document.createElement('style');
      s.id = 'ns-gift-style';
      s.textContent = STYLE_CSS;
      document.head.appendChild(s);
    }
  }

  function esc(str) { return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  function buildBox(cart, prods) {
    var st = cartState(cart);
    var qualifying = st.nonGiftQty;
    var giftInCart = st.giftLines.length > 0;
    var gp = prods[GIFT_HANDLE];
    var giftPrice = gp ? money(gp.price) : '19,00 €';
    var giftUrl = gp ? gp.url : '/products/' + GIFT_HANDLE;
    var handlesInCart = {};
    (cart.items || []).forEach(function (it) { handlesInCart[it.handle] = true; });

    var lines = [];
    if (qualifying >= 2 && giftInCart) {
      lines.push('🎉 <strong>Votre brosse pour peau de mouton OFFERTE</strong> (' + giftPrice + ') est dans le panier !');
    } else if (qualifying === 1) {
      if (!gp || gp.available) {
        lines.push('🎁 Ajoutez <strong>1 article de plus</strong> et recevez une <a href="' + giftUrl + '">brosse pour peau de mouton</a> (' + giftPrice + ') <strong>GRATUITE</strong>');
      }
    } else if (qualifying === 0) {
      lines.push('🎁 Achetez <strong>2 articles</strong> → <a href="' + giftUrl + '">brosse pour peau de mouton</a> OFFERTE (' + giftPrice + ')');
    }

    var ic = cart.item_count || 0;
    if (ic >= 4) {
      lines.push('💰 <strong>10% DE RÉDUCTION EXTRA</strong> sur toute la commande : activée !');
    } else if (ic === 3) {
      lines.push('💰 Ajoutez <strong>1 article de plus</strong> et obtenez <strong>10% DE RÉDUCTION EXTRA</strong> sur toute la commande !');
    } else if (ic > 0) {
      lines.push('💰 Dès <strong>3 articles</strong> : 10% de réduction EXTRA sur toute la commande');
    } else {
      lines.push('💰 Achetez <strong>3 articles</strong> → <strong>10% DE RÉDUCTION EXTRA</strong> sur toute la commande');
    }

    if (st.hyndeQty > 0 && st.hyndeQty < 6) {
      var missing = 6 - st.hyndeQty;
      lines.push('💺 Ajoutez <strong>' + missing + ' dessus de siège de plus</strong> et payez-en seulement 5 (6 pour 5)');
    } else if (st.hyndeQty >= 6) {
      lines.push('💺 La remise <strong>6 POUR 5</strong> sur vos dessus de siège est activée !');
    }

    FILLS.forEach(function (f) {
      if (handlesInCart[f.cover] && !handlesInCart[f.fill]) {
        var fp = prods[f.fill];
        if (fp && fp.available) {
          lines.push('🛏️ Votre housse (' + f.label + ') est sans garnissage – seulement ' + money(fp.price) +
            ' <a href="#" class="ns-quickadd" data-variant="' + fp.variants[0].id + '">Ajouter</a>');
        }
      }
    });

    if (ic > 0 && !handlesInCart[ACC_HANDLE]) {
      var ap = prods[ACC_HANDLE];
      if (ap && ap.available) {
        lines.push('🧺 Accessoire populaire : <a href="' + ap.url + '">' + esc(ap.title.split(' | ')[0]) + '</a> – ' + money(ap.price) +
          ' <a href="#" class="ns-quickadd" data-variant="' + ap.variants[0].id + '">Ajouter</a>');
      }
    }

    var bar = '<div class="ns-bar">' +
      '<span' + (qualifying >= 1 ? ' class="ns-fill"' : '') + '></span>' +
      '<span' + (qualifying >= 2 ? ' class="ns-fill"' : '') + '></span>' +
      '<span' + (qualifying >= 3 ? ' class="ns-fill"' : '') + '></span>' +
      '</div>';

    return bar + '<ul><li>' + lines.join('</li><li>') + '</li></ul>';
  }

  function hashStr(s) {
    var h = 0, i;
    for (i = 0; i < s.length; i++) { h = ((h << 5) - h + s.charCodeAt(i)) | 0; }
    return String(h);
  }

  function placeBox(container, html, position) {
    if (!container) return;
    var h = hashStr(html);
    var existing = container.querySelector(':scope > .ns-gift-steps');
    if (existing && existing.getAttribute('data-ns-hash') === h) return;
    if (existing) existing.remove();
    var div = document.createElement('div');
    div.className = 'ns-gift-steps';
    div.setAttribute('data-ns-hash', h);
    div.innerHTML = html;
    if (position === 'first' && container.firstChild) container.insertBefore(div, container.firstChild);
    else container.appendChild(div);
  }

  function decorateGiftLines(cart) {
    var rows = document.querySelectorAll('.cart-item');
    rows.forEach(function (row) {
      var m = (row.id || '').match(/Item-(\d+)$/);
      if (!m) return;
      var item = (cart.items || [])[parseInt(m[1], 10) - 1];
      if (!item) return;
      var isGift = !!(item.properties && item.properties[PROP]);
      /* Skjul BxGy-pillen paa buys-linjer (0-kr-allokering, prisen er uaendret) og paa gavelinjen (badgen siger det).
         Linjer med reel rabat (final < original, fx 6 POUR 5) beholder deres pille. */
      if (isGift || item.original_line_price === item.final_line_price) {
        row.querySelectorAll('.cart-item__discounts').forEach(function (el) { el.remove(); });
      }
      if (!isGift) return;
      if (!row.querySelector('.ns-gift-badge')) {
        var title = row.querySelector('.cart-item__title');
        if (title) {
          title.insertAdjacentHTML('afterend', '<div><span class="ns-gift-badge">🎁 Cadeau offert – GRATUIT</span></div>');
        }
      }
      var q = row.querySelector('quantity-input');
      if (q) q.classList.add('ns-gift-locked');
    });
  }

  var injectTimer = null;
  function scheduleInject() {
    if (injectTimer) clearTimeout(injectTimer);
    injectTimer = setTimeout(injectAll, 250);
  }

  function injectAll() {
    ensureStyle();
    fetch('/cart.js', { headers: { 'X-NS-Gift-UI': '1' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var needed = [GIFT_HANDLE];
      var handlesInCart = {};
      (cart.items || []).forEach(function (it) { handlesInCart[it.handle] = true; });
      FILLS.forEach(function (f) { if (handlesInCart[f.cover] && !handlesInCart[f.fill]) needed.push(f.fill); });
      if ((cart.item_count || 0) > 0 && !handlesInCart[ACC_HANDLE]) needed.push(ACC_HANDLE);
      Promise.all(needed.map(getProduct)).then(function () {
        var html = buildBox(cart, productCache);
        if ((cart.item_count || 0) > 0) {
          document.querySelectorAll('[id^="CartDrawerBody-"]').forEach(function (el) { placeBox(el, html, 'first'); });
          var mainCart = document.querySelector('[id^="MainCart-"]');
          if (mainCart) {
            var ci = mainCart.querySelector('cart-items');
            placeBox(ci && ci.parentNode ? ci.parentNode : mainCart, html, 'first');
          }
        } else {
          document.querySelectorAll('[id^="CartDrawerEmpty-"] .cart-drawer__empty').forEach(function (el) { placeBox(el, html, 'first'); });
        }
        decorateGiftLines(cart);
      });
    }).catch(function () {});
  }

  document.addEventListener('cart:updated', scheduleInject);
  document.addEventListener('product-ajax:added', scheduleInject);

  function startObserver() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      var body = d.querySelector('[id^="CartDrawerBody-"]');
      var empty = d.querySelector('[id^="CartDrawerEmpty-"] .cart-drawer__empty');
      var boxMissing = (body && !body.querySelector(':scope > .ns-gift-steps')) &&
                       (empty && !empty.querySelector(':scope > .ns-gift-steps'));
      if (!boxMissing) return;
      pending = true;
      setTimeout(function () { pending = false; scheduleInject(); }, 150);
    }).observe(d, { childList: true, subtree: true });
  }

  function start() {
    setTimeout(reconcile, 300);
    setTimeout(injectAll, 500);
    setTimeout(startObserver, 600);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
